<template lang="pug">
div
  span(data-test="email-icon" data-id="candidate-email" v-if="!isSend" @click="showModal")
    v-icon() mdi-email
  v-tooltip(top v-else data-test="email-icon" data-id="candidate-bov")
    template(v-slot:activator="{ on }")
      div( v-on="on").bov bov
    span {{ sendAtFormatted }}
  
  accept-dialog(
    data-test="candidate-email-modal"
    title="Sending BOV mail"
    descr="Are you sure you want to send BOV mail?"
    v-model="showing"
    @okBtnClicked="send"
  )
</template>

<script>
import {mapGetters} from "vuex"

import errMixin from "@/mixins/errors.mixin"
import { convertToDefaultDateHourFormat } from '../../../../../util'
export default {
  mixins: [errMixin],

  props :{
    isSend: {
      type: Boolean,
      default: false,
      required: true
    },
    ID: {
      type: Number,
      requred: true
    },
    sendAt: {
      reqired: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    showing: false
  }),

  inject: ['svc'],

  computed: {
    sendAtFormatted() {
      if(!this.sendAt) return ''
      return convertToDefaultDateHourFormat(this.sendAt)
    }
  },

  methods: {
    Svc() {
      return this.svc()
    },
    showModal() {
      this.showing = true
    }, 

    async send() {
      try {
        await this.Svc().sendBOV(this.ID)
        this.showing  = false
        this.$emit('sended')
        this.model.BOVSentAt = Date.now()
      } catch (error) {
        console.log(error)
        this.showing = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
      
    }
  },

  components: {
    acceptDialog: () => import('@/components/global/ConfirmationDialog.vue')
  }
}
</script>

<style lang="scss" scoped>
.icon-email {
  width: 20px;
}
.bov {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 16px;
  border-radius: 4px;
  background-color: #39CE73;
  color: #FFFFFF;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 9px;
}

</style>